import { useTranslation } from 'react-i18next'

export default function NotesSection({ form, setField }) {
	const { t } = useTranslation()

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-3">
			<div>
				<label className="block text-sm font-medium text-gray-700 mb-1">{t('korekty.form.notes.public')}</label>
				<textarea
					rows={3}
					value={form.publicNotes}
					onChange={e => setField('publicNotes', e.target.value)}
					className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 resize-none"
					placeholder={t('korekty.form.notes.publicPlaceholder')}
				/>
			</div>
			<div>
				<label className="block text-sm font-medium text-gray-700 mb-1">{t('korekty.form.notes.private')}</label>
				<textarea
					rows={3}
					value={form.privateNotes}
					onChange={e => setField('privateNotes', e.target.value)}
					className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 resize-none"
					placeholder={t('korekty.form.notes.privatePlaceholder')}
				/>
			</div>
		</div>
	)
}
